import { Custom } from '@app/shared/dynamic-form';
import { Injectable } from '@angular/core';
import { BaseControl, Textbox, EtapaBase } from '@app/shared';
import { Validators } from '@angular/forms';
import { EtapaDetalleApi } from '../../../../../shared/models/tramite.model';
import { InfoStages } from '../tramit-stages.component';

@Injectable()
export class TramitStagesFormService {
  constructor() { }


  /**
   * Retorna el formulario de detalles de la etapa
   *
   * @param {*} templetesFomr
   * @param {*} options
   * @param {StageDetail} [stageDetail]
   * @return {*}  {BaseControl<any>[]}
   * @memberof TramitStagesFormService
   */
  getFormTramitStage(templetesFomr?: any, options?: any, stageDetail?: InfoStages): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboEtapa',
        label: 'Etapa',
        order: 1,
        template: templetesFomr.ngSelect,
        placeholder: 'Seleccione la etapa',
        value: stageDetail ? stageDetail.etapa_id ? stageDetail.etapa_id : null : null,
        options: options && options['value'] ? options['value'] : [],
        validations: {
          validators: [Validators.required]
        }
      }), new Textbox({
        key: 'txtTiempo',
        value: stageDetail && stageDetail.tiempo ? stageDetail.tiempo : null,
        label: 'Tiempo',
        placeholder: 'Ingrese el tiempo',
        order: 2,
        validations: {
          validators: [Validators.required]
        }
      }), new Textbox({
        key: 'txtPorcentajeAlerta',
        value: stageDetail && stageDetail.porcentaje_alerta ? stageDetail.porcentaje_alerta : null,
        label: 'Porcentaje de alerta',
        placeholder: 'Ingrese el porcentaje de alerta',
        order: 3,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'chHabiles',
        type: 'checkbox',
        value: stageDetail && stageDetail.dias_habiles ? stageDetail.dias_habiles : false,
        label: 'Dias Hábiles',
        order: 4,
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/tramit-stages/shared/tramit-stages.form.service.ts